import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　仕様確認表を出力するサービス
 *
 * @export OutputSpecConfirmListService
 * @class OutputSpecConfirmListService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class OutputSpecConfirmListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof OutputSpecConfirmListService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof OutputSpecConfirmListService
   */
  private vo: {
    orderCode: '',
    pCodeList: [],
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof OutputSpecConfirmListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputSpecConfirmListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        OutputSpecConfirmList: {
          condition: {
            OrderCode: this.vo.orderCode
          },
          combination: this.vo.pCodeList.map(pCode => {
            return {
              condition: {
                PCodeList: pCode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof OutputSpecConfirmListService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputSpecConfirmList', this.getBody());
  }


  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputSpecConfirmListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
